import { Divider, Grid } from '@mui/material';
import { memo } from 'react';
import { AccordionGeneralityFormVM } from 'front-office/view-models/certificate/generality-form';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import { FormikErrors, FormikTouched } from 'formik';
import ItalianForeignStateDocument from '../../generality/release-card/italian-foreign-state-document';

interface DocumentProps {
  onChange: (
    key: keyof AccordionGeneralityFormVM,
    value: AccordionGeneralityFormVM[keyof AccordionGeneralityFormVM]
  ) => void;
  onChangeValues: (values: AccordionGeneralityFormVM) => void;
  errors?: FormikErrors<AccordionGeneralityFormVM>;
  touched?: FormikTouched<AccordionGeneralityFormVM>;
  values?: AccordionGeneralityFormVM;
}

const DocumentComponent = ({
  onChange,
  values,
  errors,
  touched,
  onChangeValues,
}: DocumentProps): React.ReactElement => {
  return (
    <Grid
      item
      container
      spacing={0}
      columnSpacing={{ xs: 0, md: 1 }}
      rowSpacing={1}
      alignItems="center"
    >
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <PmiTitleDivider>Documento di riconoscimento</PmiTitleDivider>
      </Grid>
      <Grid item xs={12}>
        <ItalianForeignStateDocument
          isForeign={values?.isForeignDocument}
          values={values}
          onChange={onChange}
          errors={errors}
          touched={touched}
          onChangeValues={onChangeValues}
        />
      </Grid>
    </Grid>
  );
};

DocumentComponent.displayName = 'Section document component';

const Document = memo(DocumentComponent);

export default Document as typeof DocumentComponent;
